import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetPaginatedOpenEndedResponsesRPC } from "./getPaginatedOpenEndedResponsesRPC";

export class GetPaginatedOpenEndedResponsesRPCClientImpl extends GetPaginatedOpenEndedResponsesRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetPaginatedOpenEndedResponsesRPC.Request): Promise<LeoRPCResult<GetPaginatedOpenEndedResponsesRPC.Response, GetPaginatedOpenEndedResponsesRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-dashboard/GetPaginatedOpenEndedResponses",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetPaginatedOpenEndedResponsesRPC.ResponseDTO,
      GetPaginatedOpenEndedResponsesRPC.Errors.ErrorsDTO,
      GetPaginatedOpenEndedResponsesRPC.Response,
      GetPaginatedOpenEndedResponsesRPC.Errors.Errors
    >(
      response,
      "survey-dashboard/GetPaginatedOpenEndedResponses",
      GetPaginatedOpenEndedResponsesRPC.Response.fromDTO,
      GetPaginatedOpenEndedResponsesRPC.Errors.fromDTO
    );
  }
}
